export function generateUniqueUUID(existingIds: Set<string>): string {
  let newId: string;
  do {
    newId = crypto.randomUUID();
  } while (existingIds.has(newId));
  return newId;
}
